import {
  Box,
  Button,
  Container,
  Link,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import React, { useEffect, useState } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import logoHeader from "assets/images/color-logo.svg";

import star from "assets/images/Vector.svg";
import { useDispatch, useSelector } from "react-redux";

import Footer from "layouts/home/components/footer";

import facebook from "../../../assets/images/Facebook.png";
import yelp from "assets/images/yelp.png";
import google from "assets/images/google.png";
import {
  reviewRequestByLink,
  markReviewDonRequest,
} from "features/actions/auth";
import { markReviewRequestDoneAsync } from "features/actions/auth";
import { getReviewRequestByIdCrmAsync } from "features/actions/auth";

const Redirect = () => {
  const dispatch = useDispatch();

  const { reviewRequestLink,getReviewRequestByIdCRM } = useSelector((state) => state.auth);
  const navigate = useNavigate();
  const location = useLocation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const queryParams = new URLSearchParams(location.search);
  const link = queryParams.get("link");
  const newLink = link?.split(`${window.location.host}/redirect/`).pop();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
   const fetchRequestByLink = async () => {
  setLoading(true);
  const request_id = newLink;
  try {
    const formData = new FormData();
    formData.append("request_id", request_id); 
    await dispatch(getReviewRequestByIdCrmAsync(formData)); 
  } catch (error) {
    console.error("Error fetching Request By Link:", error);
  } finally {
    setLoading(false);
  }
};


    fetchRequestByLink();
  }, [link, dispatch]);

  const handleGoogle = () => {
    const selectedData = getReviewRequestByIdCRM?.business?.business_google_page;
    console.log(selectedData, "business_google_page");
    const payload = {
      review_request_id: getReviewRequestByIdCRM?.review_request.review_request_id,
    }
    dispatch(markReviewRequestDoneAsync({payload}));
    // dispatch(markReviewDonRequest(formData));
  };
  const handleFacebook = () => {
    const selectedData = getReviewRequestByIdCRM?.business?.business_fb_page;
    console.log(selectedData, "business_fb_page");
    const payload = {
      review_request_id: getReviewRequestByIdCRM?.review_request.review_request_id,
    }
    dispatch(markReviewRequestDoneAsync({payload}));
  };
  const handleYelp = () => {
    const selectedData = getReviewRequestByIdCRM?.business?.business_yelp_page;
    console.log(selectedData, "business_yelp_page");
    const payload = {
      review_request_id: getReviewRequestByIdCRM?.review_request.review_request_id,
    }
    dispatch(markReviewRequestDoneAsync({payload}));
  };

  const renderReviewButton = (platform, icon, label, onClick) => (
    <NavLink to={platform} style={{ textDecoration: "none" }}>
      <Button
        onClick={onClick}
        sx={{
          border: "1px dashed #318BEC",
          borderRadius: 2,
          minHeight: 40,
          px: 3,
          display: "flex",
          gap: 1,
          alignItems: "center",
          backgroundColor: "#fff",
          textTransform: "none",
          "&:hover": { backgroundColor: "#f0f0f0" },
        }}
      >
        <img src={icon} alt={label} style={{ width: 26, height: 26 }} />
        {label}
      </Button>
    </NavLink>
  );
  return (
    <>
      {/* Header */}
      <Box
        sx={{
          backgroundColor: "#f5faff",
          position: "sticky",
          top: 0,
          zIndex: 1100,
          boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.05)",
        }}
      >
        <Container
          sx={{ "@media (min-width:1580px)": { maxWidth: "1600px!important" } }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              py: 1,
              "@media(max-width: 720px)": { px: 2 },
            }}
          >
            <MDBox sx={{ width: "100%", margin: "auto", textAlign: "start" }}>
              <NavLink to="/">
                <MDBox>
                  <img src={logoHeader} alt="logo" />
                </MDBox>
              </NavLink>
            </MDBox>

            <MDButton
              component={Link}
              sx={{
                background: "#318BEC",
                color: "#fff",
                border: "2px solid #318BEC",
                padding: "9px 40px",
                borderRadius: "188px",
                fontSize: "16px",
                fontWeight: "700",
                lineHeight: "24px",
                fontFamily: "urbanist",
                textTransform: "none",
                "&:hover": { background: "#318BEC" },
              }}
              onClick={() => navigate("/sign-in")}
            >
              Login
            </MDButton>
          </Box>
        </Container>
      </Box>

      {/* Section */}

      <Container
        maxWidth="md"
        sx={{
          height: isMobile ? "auto" : "71vh",
          py: isMobile ? 5 : 8,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Box
          sx={{
            position: "relative",
            background: "#D0E5FA",
            width: "100%",
            maxWidth: 800,
            minHeight: 365,
            p: isMobile ? 3 : 5,
            textAlign: "center",
            borderRadius: 2,
            paddingTop: 5,
          }}
        >
          {/* Star Icon */}
          <Box
            sx={{
              position: "absolute",
              top: isMobile ? 18 : -26,
              left: isMobile ? 16 : "auto",
              right: isMobile ? "auto" : 16,
              width: isMobile ? 56 : 76,
            }}
          >
            <img
              src={star}
              alt="star"
              style={{ width: "80%", paddingTop: 5 }}
            />
          </Box>

          {/* Text Content */}
          <MDTypography
            sx={{
              color: "#212121",
              fontSize: isMobile ? 28 : 48,
              fontWeight: "700",
              fontFamily: "Urbanist",
              mb: 2,
            }}
          >
            <span style={{ color: "#318BEC" }}>Leave a Review</span>
          </MDTypography>

          <Box sx={{ mb: 3 }}>
            <Typography
              variant="h5"
              sx={{
                fontWeight: 700,
                fontFamily: "Urbanist",
                fontSize: { xs: "22px", sm: "28px" },
                color: "#212121",
              }}
            >
              {getReviewRequestByIdCRM?.business?.restaurant_name}
            </Typography>
            <Typography
              variant="body1"
              sx={{
                mt: 1,
                fontSize: { xs: "14px", sm: "16px" },
                color: "#555",
                fontFamily: "Urbanist",
              }}
            >
              {getReviewRequestByIdCRM?.business?.business_address}
            </Typography>
          </Box>

          {/* Review Buttons */}
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 2,
              alignItems: "center",
              width: "100%",
            }}
          >
            {getReviewRequestByIdCRM?.business?.business_google_page &&
              renderReviewButton(
                getReviewRequestByIdCRM.business.business_google_page,
                google,
                "Leave a Review on Google",
                () => handleGoogle("google")
              )}
            {getReviewRequestByIdCRM?.business?.business_fb_page &&
              renderReviewButton(
                getReviewRequestByIdCRM.business.business_fb_page,
                facebook,
                "Leave a Review on Facebook",
                () => handleFacebook("facebook")
              )}
            {getReviewRequestByIdCRM?.business?.business_yelp_page &&
              renderReviewButton(
                getReviewRequestByIdCRM.business.business_yelp_page,
                yelp,
                "Leave a Review on Yelp",
                () => handleYelp("yelp")
              )}
          </Box>
        </Box>
      </Container>

      <Footer />
    </>
  );
};

export default Redirect;
